module.exports = __webpack_public_path__ + "img/edi-2.c7c914b0.png";